import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, theme } from "@clockwise/web-commons/src/styles/color.styles";

const textFieldContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "baseline",
  justifyContent: "space-between",
};

const textField: CSSProperties = {
  width: 300,
};

const empty: CSSProperties = {
  color: theme.textSecondary,
  padding: "12px 0",
};

const selectAllButton: CSSProperties = {
  marginLeft: "auto",
  marginRight: 13,
  color: greys.slate,
  fontWeight: 600,
};

const selectAllLabel: CSSProperties = {
  margin: "4px 0 0 5px",
  whiteSpace: "nowrap",
};

export const styles = {
  textFieldContainer,
  textField,
  empty,
  selectAllButton,
  selectAllLabel,
};
